import styled from "styled-components";
import { colors, values } from "../../theme/constants";

export const SearchContainer = styled.div`
    position: relative;
    background-color: ${colors.WHITE};
    padding-top: 5px;
    input {
        border-radius: 30px;
        font-size: 18px;
        padding-left: 42px;
        border: 1px solid ${colors.LAYOUT.GRAY[400]};
        background-color: ${colors.WHITE};
        transition: ${values.DEFAULT_TRANSITION_DURATION};
        width: 100%;
        outline: none !important;
        &:active,
        &:focus {
            background-color: ${colors.LAYOUT.GRAY[100]};
            border-color: ${colors.SEMANTIC.WARNING[1000]};
            outline: none !important;
            width: 100%;
        }

        input:hover,
        input:active,
        input:focus {
            background: #ffffff;
        }
    }
`;

export const ToolIcon = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    top: 10px;
    bottom: 0;
    transition: ${values.DEFAULT_TRANSITION_DURATION};
    cursor: ${(props) => (props.focused ? "pointer" : "default")};
`;

export const CatMenu = styled.div`
    background-color: #ffffff;
    position: absolute;
    width: ${(props) => props.width}px;
    z-index: 999999;
    //box-shadow: 0px 4px 8px #00000020;
    border-radius: 10px;
    margin-top: 1px;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 65vh;
    transition: 300ms;
    &.visible {
        opacity: 1;
    }
    &.invisible {
        opacity: 0;
        visibility: hidden;
    }
`;

export const RestaurantIconContainer = styled.div`
    height: 36px;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 18px;
    background-color: ${colors.BRAND.PRIMARY[100]};
`;
